'use client'

import { Dispatch, FC, SetStateAction, useMemo } from 'react'
import { useCustomRouter } from '@/root/shared-hooks'
import { HeaderNavBarProps } from '@/root/shared-types'
import { ContentContainer } from '@/root/components/shared'
import Link from 'next/link'
import Image from 'next/image'
import { Hamburger } from '@/root/ui/tuuleliinid/Hamburger/Hamburger'

interface MainHeaderNavBarProps extends HeaderNavBarProps {
  setMobileMenuOpen: Dispatch<SetStateAction<boolean>>
}

const MainHeaderNavBar: FC<MainHeaderNavBarProps> = ({ menuItems, setMobileMenuOpen }) => {
  const { locale } = useCustomRouter()
  const logoAdm = '/tuuleliinid/icons/logo-tuuleliinid.svg'

  const items = useMemo(() => menuItems.slice(0, 8), [menuItems])

  return (
    <div className="bg-white">
      <ContentContainer className="mx-auto flex w-full max-w-6xl items-center justify-between gap-8 p-4">
        <Link href={`/${locale}`} className="shrink-0">
          <Image alt="tuuleliinid logo" src={logoAdm} width={160} height={44} />
        </Link>

        <div className="shrink-0 md:hidden">
          <Hamburger onClick={() => setMobileMenuOpen(true)} />
        </div>

        <nav className="hidden min-w-0 flex-1 md:flex">
          <ul
            className={
              items.length > 4
                ? 'text-primary-base ml-auto flex w-full max-w-[950px] items-center justify-between gap-3 text-lg font-bold xl:gap-5 xl:text-base'
                : 'text-primary-base ml-auto flex w-full max-w-[821px] items-center justify-between gap-4 text-lg font-extrabold'
            }
          >
            {items.map(({ id, link, subject }) => (
              <li key={id} className="darken text-center">
                <Link href={`/${locale}${link}`}>{subject}</Link>
              </li>
            ))}
          </ul>
        </nav>
      </ContentContainer>
    </div>
  )
}

export default MainHeaderNavBar
